<template>
<div class="ownersection" v-if="get_shop_owner">
    <div class="container">
        <div class="row row_owner">
            <div class="col-md-6">
                <div class="img_user">
                    <img :src="get_shop_owner.image_one" alt="">
                </div>
            </div>
            <div class="col-md-6">
                 <div class="text_owner">
                    <h2 class="t1">{{get_shop_owner.title}}</h2>
                    <h1 class="t2">{{get_shop_owner.subtitle}}</h1>
                    <p class="desc" v-html="get_shop_owner.description"></p>
                    <img :src="get_shop_owner.image_two" alt="">
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "ownerArea",
       computed:{
    ...mapGetters({
        get_shop_owner:'get_shop_owner',
    })
  },
    methods:{
    ...mapActions({
       shop_owner_api:'shop_owner_api',
    }),
    },
    mounted(){
       this.shop_owner_api();
    }
}
</script>
<style lang="scss" scoped>
.ownersection{
    margin-top: 80px;
    background-image: url('~@/assets/owner3.svg');
    background-position: bottom left;
    background-repeat: no-repeat;
    background-size: 50vw auto;
    .row_owner{
        align-items: center;
        .img_user{
            text-align: center;
            margin-left: -25%;
        }
        .text_owner{
            margin-top: -40px;
            padding-left: 40px;
            img{
                margin-top: 30px;
            }
        }

    }
    .text_owner p:first-of-type{
          margin-bottom: 25px;
        }
}

// STYLE MEDIA QUERY
@media(max-width:992px){
.ownersection {
    margin-top: 40px;
}
}
@media(max-width:767px){
    .ownersection {
    margin-top: 40px;
    background-position: top left;
    background-repeat: no-repeat;
    background-size: 100vw auto;
}
.ownersection .row_owner .text_owner {
    margin-top: 40px;
    padding-left: 0px;
}
h2.t1 {
    font-size: 1rem;
}
h1.t2 {
    font-size: 2rem;
}
p{
    font-size: 15px;
}
.ownersection .row_owner .img_user{
    text-align: center;
     margin-left: 0%; 
}
.img_user{
    img{
        width: 80%;
    }
}


}

</style>